import {
  INFO_TYPE,
  WARNING_TYPE,
  SUCCESS_TYPE,
  ERROR_TYPE,
} from '@sv-support-sdk/shared-types/src/common/notifications';
import { TNotificationType } from '@sv-support-sdk/utils/src/constants/notifications';
import generateId from '@sv-support-sdk/utils/src/helpers/generateId';

import { TThunk } from '../../..';
import { notificationsActions } from '../../../config';

interface INotifyParams {
  title: string;
  message: string;
}

interface ITypeNotifyParams {
  type: TNotificationType;
  title: string;
  message: string;
}

const notify =
  (params: ITypeNotifyParams): TThunk =>
  (dispatch) => {
    dispatch(notificationsActions.addNotification({ id: generateId(), ...params }));
  };

export const notifySuccess =
  (params: INotifyParams): TThunk =>
  (dispatch) => {
    dispatch(notify({ type: SUCCESS_TYPE, ...params }));
  };

export const notifyInfo =
  (params: INotifyParams): TThunk =>
  (dispatch) => {
    dispatch(notify({ type: INFO_TYPE, ...params }));
  };

export const notifyWarning =
  (params: INotifyParams): TThunk =>
  (dispatch) => {
    dispatch(notify({ type: WARNING_TYPE, ...params }));
  };

export const notifyError =
  (params: INotifyParams): TThunk =>
  (dispatch) => {
    dispatch(notify({ type: ERROR_TYPE, ...params }));
  };
